import XLSX from "xlsx";
import { dateType } from "../components/table/cell/fields";
import { getStringFromList } from "../helpers/defaultReturnFunction";
import { impexDateFormat } from "./dateManager";

export const getExportableData = (data, columns) => {
  const exportableData = [];
  for (const item of data) {
    const tempRow = {};
    for (const col of columns) {
      if (col.exportable === true) {
        if (dateType.includes(col.accessor)) {
          if (item[col.accessor]) {
            tempRow[col.Header] = impexDateFormat(item[col.accessor]);
          } else {
            tempRow[col.Header] = "";
          }
        } else if (col.accessor === "PartNo") {
          tempRow[col.Header] = getStringFromList(item[col.accessor]);
        } else {
          tempRow[col.Header] = item[col.accessor];
        }
      }
    }
    exportableData.push(tempRow);
  }
  return exportableData;
};

export const exportData = (data, fileName) => {
  var dataOfExcel = XLSX.utils.json_to_sheet(data);
  var wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, dataOfExcel, "data");
  XLSX.writeFile(wb, `${fileName}.xlsx`);
};
